import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';

import {labels as utilLabels} from '../../../util/utils';

import OutputText from '@ey/canvascoreservices/OutputText';

import Button from '../Button';
import StyledShowMoreLess from './StyledShowMoreLess';

const ShowMoreLess = ({
	text = '',
	numLines = 2,
	labels = {showMore: utilLabels.showMore, showLess: utilLabels.showLess},
	initialEllipsed = true,
	fontSize = 'body2'
}) => {
	const [ellipsed, setEllipsed] = useState(initialEllipsed);
	const [showButton, setShowButton] = useState(false);

	const innerTextRef = useRef(null);

	useEffect(() => {
		let timerId = setTimeout(() => {
			const textHolder = innerTextRef?.current?.querySelector('span');
			const newShowButton = initialEllipsed ? textHolder?.scrollHeight > textHolder?.clientHeight : true;
			setShowButton(newShowButton);
		}, '10');

		return () => clearTimeout(timerId);
	}, [text]);

	const renderControl = () => {
		const props = {
			variant: 'text-alt',
			label: ellipsed ? labels.showMore : labels.showLess,
			size: 'small',
			onClick: () => setEllipsed(!ellipsed)
		};

		return <Button {...props} />;
	};

	const props = {};
	if (ellipsed) {
		props.ellipsis = true;
		props.multilineEllipsis = numLines;
	}
	if (fontSize === 'body1') props.body1 = true;
	if (fontSize === 'body2') props.body2 = true;

	return (
		<StyledShowMoreLess ref={innerTextRef}>
			<OutputText {...props} light>
				{text}
			</OutputText>
			{showButton && renderControl()}
		</StyledShowMoreLess>
	);
};

ShowMoreLess.propTypes = {};

export default ShowMoreLess;
